import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import cloneDeep from 'lodash/cloneDeep';
import { TYPOLOGIE_AUCUN, LISTE_TYPOLOGIE } from '@/configuration/tiers/tiersConf';
import i18n from '@/i18n';

export function initialiseClientAutoComplete(client) {
  let clientAdresse = adressFullStringGetter(client.adressePostale, false);
  if (client.adresseFacturationDifferente) {
    clientAdresse = adressFullStringGetter(client.adresseFacturation, false);
  }
  client.nomCommercialAvecVille = client.nomCommercial;
  const typologie = LISTE_TYPOLOGIE.find((typo) => typo.code === client.typologie);
  if (typologie.code !== TYPOLOGIE_AUCUN) {
    client.nomCommercialAvecVille += ` (${i18n.t(typologie.libelle)})`;
  }
  if (clientAdresse) {
    client.nomCommercialAvecVille += ' | ' + clientAdresse;
  }
  if (client.compteComptable) {
    client.nomCommercialAvecVille += ' | ' + client.compteComptable;
  }
}

export function initialiseContactAutoComplete(contact, client) {
  const clientContact = cloneDeep(client);
  let adresse = clientContact.adressePostale;
  if (contact.adresseContactDifferente) {
    adresse = contact.adresse;
  }
  adresse = adressFullStringGetter(adresse, false);
  clientContact.nomCommercialAvecVille = clientContact.nomCommercial;
  clientContact.contact = cloneDeep(contact);
  clientContact.nomCommercialAvecVille += ' - ' + nomPrenomGetter(contact);
  if (adresse) {
    clientContact.nomCommercialAvecVille += ' | ' + adresse;
  }
  if (clientContact.compteComptable) {
    clientContact.nomCommercialAvecVille += ' | ' + clientContact.compteComptable;
  }
  return clientContact;
}

export function nomCommercialePourIntervenant(intervenant) {
  intervenant.nomCommercial = intervenant.nomCommercial.split('|')[0];
}
